import { TS_Note }              from '../TravelSeller/Models/TS_Note';
import { BookingItemInterface } from './BookingItemInterface';

export class Note extends TS_Note implements BookingItemInterface {}